import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const Disconnect = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 18"
    fill="none">
    <path
      d="M12.9428 10.152L14.357 8.73782C15.6588 7.43607 15.6588 5.32552 14.357 4.02377V4.02377C13.0553 2.72202 10.9447 2.72202 9.64298 4.02377L8.22876 5.43798M11.0572 12.0376L9.64298 13.4519C8.34123 14.7536 6.23068 14.7536 4.92893 13.4519V13.4519C3.62718 12.1501 3.62718 10.0396 4.92893 8.73782L6.34315 7.3236"
      stroke="#EF4A3C"
      strokeLinecap="round"
    />
    <path
      d="M7.05233 5.10642L6.6665 3.6665"
      stroke="#EF4A3C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.15779 6.06609L4.6665 5.6665"
      stroke="#EF4A3C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2807 12.2266L12.6665 13.6665"
      stroke="#EF4A3C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1752 11.2669L14.6665 11.6665"
      stroke="#EF4A3C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Disconnect;
